import { useEffect, useRef, useState } from "react";
import { CalendarDays } from "lucide-react";

function displayValue(value) {
  if (!value) return "";
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : "";
}

function inputValue(value) {
  const match = String(value).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return null;
  const [, day, month, year] = match;
  const iso = `${year}-${month}-${day}`;
  const date = new Date(`${iso}T00:00:00.000Z`);
  return (
    date.getUTCFullYear() === Number(year)
    && date.getUTCMonth() + 1 === Number(month)
    && date.getUTCDate() === Number(day)
  ) ? iso : null;
}

function formatTyping(value) {
  const digits = String(value).replace(/\D/g, "").slice(0, 8);
  return [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)]
    .filter(Boolean)
    .join("/");
}

export function ArgentineDateInput({
  value = "",
  onChange,
  required = false,
  disabled = false,
  name,
  id,
  min,
  max,
  ...inputProps
}) {
  const [text, setText] = useState(() => displayValue(value));
  const textRef = useRef(null);
  const pickerRef = useRef(null);

  useEffect(() => {
    setText(displayValue(value));
  }, [value]);

  function validate(nextText) {
    const iso = inputValue(nextText);
    const message = !nextText && !required
      ? ""
      : iso
        ? ""
        : "Ingresá una fecha válida con formato DD/MM/AAAA.";
    textRef.current?.setCustomValidity(message);
    return iso;
  }

  function handleTextChange(event) {
    const nextText = formatTyping(event.target.value);
    setText(nextText);
    const iso = validate(nextText);
    if (!nextText) onChange?.("");
    else if (iso) onChange?.(iso);
  }

  function openPicker() {
    if (typeof pickerRef.current?.showPicker === "function") {
      pickerRef.current.showPicker();
    } else {
      pickerRef.current?.click();
    }
  }

  return (
    <div className="argentine-date-input">
      <input
        {...inputProps}
        ref={textRef}
        id={id}
        name={name}
        type="text"
        inputMode="numeric"
        placeholder="DD/MM/AAAA"
        autoComplete="off"
        value={text}
        required={required}
        disabled={disabled}
        onChange={handleTextChange}
        onBlur={() => validate(text)}
      />
      <button
        type="button"
        aria-label="Abrir calendario"
        disabled={disabled}
        onClick={openPicker}
      >
        <CalendarDays size={17} />
      </button>
      <input
        ref={pickerRef}
        className="argentine-date-native-picker"
        type="date"
        tabIndex={-1}
        aria-hidden="true"
        value={value}
        min={min}
        max={max}
        onChange={(event) => {
          const nextValue = event.target.value;
          setText(displayValue(nextValue));
          textRef.current?.setCustomValidity("");
          onChange?.(nextValue);
        }}
      />
    </div>
  );
}
